export const isOutOfService = function (car) {
    const carType = {
        normal: 1,
        marshal: 2,
        handicap: 3,
        bevcart: 4,
        outOfService: 5,
        member: 6,
    };
    return car.CarType === carType.outOfService;
 };